import React, { FC, Fragment } from 'react';

import { LucidTheme } from '@lucid/theme';

import Box from '../box/box';
import Heading from '../heading/heading';
import Link from '../link/link';
import Text from '../text/text';
import VisibleLottie from '../visible-lottie/visible-lottie';
import { BaseCarouselProps, BaseCarouselMobileImageProps } from './carousel';

export interface CarouselMobileProps extends BaseCarouselProps, BaseCarouselMobileImageProps {}

const CarouselMobile: FC<CarouselMobileProps> = (
  {
    cta,
    items,
    shouldOverflowMobileImages
  }
) => {
  return (
    <Box
      css={
        {
          label: 'mobileCarousel',
          flex: '0 1 100%',
          flexDirection: 'column',
        }
      }
    >
      {items.map((item, index) => {
        const {
          animation,
          footerText,
          heading,
          image,
          subheading,
        } = item;

        const hasAnimation = animation?.data;
        return (
          <Fragment key={`carousel-item-${index}`}>
            <Box
              css={(theme: LucidTheme) => ({
                display: 'flex',
                flexDirection: 'column',
                marginBottom: theme.space[4],
                marginTop: theme.space[8],
                '&:first-of-type': {
                  marginTop: theme.space[0]
                }
              })}
            >
              <Heading
                as="h5"
                css={(theme: LucidTheme) => [
                  {
                    marginBottom: theme.space[0],
                    textAlign: 'left'
                  }
                ]}
                variant="headline3XL"
              >
                {heading}
              </Heading>
              {subheading && !footerText && (
                <Text
                  css={(theme: LucidTheme) => ({
                    marginTop: theme.space.s32,
                    marginBottom: theme.space[0]
                  })}
                  variant="paragraphS400"
                >
                  {subheading}
                </Text>
              )}
            </Box>
            {
              hasAnimation ? (
                <Box
                  css={(theme: LucidTheme) => [
                    {
                      backgroundColor: theme.colors.coolGrey[0],
                      marginBottom: theme.space[3],
                    },
                    shouldOverflowMobileImages && {
                      width: '200%',
                      transform: 'translateX(-25%)',
                    },
                    {
                      '.carouselLottie': {
                        background: 'url("https://cdn-cashy-static-assets.lucidchart.com/lucidspark/marketing/pages/home/canvas-grid.svg") center center no-repeat',
                        backgroundSize: 'cover'
                      }
                    }
                  ]}
                >
                  <VisibleLottie
                    className="carouselLottie"
                    data={animation?.data!}
                  />
                </Box>
              ) :
                  (
                    <img
                      alt={image!.imageAlt!}
                      css={(theme: LucidTheme) => ({
                        objectFit: 'contain',
                        width: '100%',
                        left: 0,
                        position: 'relative',
                        maxWidth: 'unset',
                        paddingBottom: theme.space[3],
                      })}
                      loading="lazy"
                      src={image!.imageSrc!}
                    />
                  )
            }
            {footerText && !subheading && (
              <Text
                css={(theme: LucidTheme) => ({
                  marginBottom: theme.space[0],
                  textAlign: 'left'
                })}
                variant="paragraphS400"
              >
                {footerText}
              </Text>
            )}
          </Fragment>
        );
      })}
      {cta && (
        <Box
          css={{
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          {cta.linkUrl && (
            <Link displayAsButton primary to={cta.linkUrl}>
              {cta.linkText}
            </Link>
          )}
        </Box>
      )}
    </Box>
  );
};

export { CarouselMobile };
export default CarouselMobile;
